import { z } from "zod";

import { FIELD_TYPE, FILTER_TYPE } from "./constants";

export const filterTypeSchema = z.enum(FILTER_TYPE);

const formFieldSchema = z.object({
  id: z.string(),
  label: z.string().catch(""),
  required: z.boolean(),
  options: z.array(z.string()),
  type: z.enum(FIELD_TYPE),
  customModuleCondition: z
    .object({
      filterType: filterTypeSchema,
      valueToFilter: z.string(),
      conditionalCustomModuleId: z.string(),
      customModuleId: z.string(),
    })
    .nullable(),
  value: z.string().nullable(),
});

export const formSchema = z.object({
  formId: z.string(),
  fields: z.array(formFieldSchema),
});
